import { render, staticRenderFns } from "./gdkmzyxy.vue?vue&type=template&id=23a4f9bb&scoped=true&"
import script from "./gdkmzyxy.vue?vue&type=script&lang=js&"
export * from "./gdkmzyxy.vue?vue&type=script&lang=js&"
import style0 from "./gdkmzyxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./gdkmzyxy.vue?vue&type=style&index=1&id=23a4f9bb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a4f9bb",
  null
  
)

export default component.exports